<template>
  <div>
    <div style="margin-bottom: 20px">
<!--      <el-button-->
<!--        type="primary"-->
<!--        size="small"-->
<!--        @click="showAddList"-->
<!--        v-show="pms['1']&&pms['1'].indexOf('demo_add')!=-1"-->
<!--        >-->
<!--        新增-有权限判断-->
<!--      </el-button>-->
      <el-button
        type="primary"
        size="small"
        @click="showAddList"
      >
        新增-有权限判断
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="importExcle"
      >
        导入
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="exportTable"
      >
        导出
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="openInvoiceType"
      >
        弹框
      </el-button>
    </div>
    <bsp-table
      :data.sync="list"
      ref="accountTable"
      @select-change="selectChange"
      @select-all="selectAll"
      :ciic-data-filter.sync="listQuery"
      @ciic-data-refresh="_getListpage"
      :footer-method="footerMethod"
      :showPagination="listQuery.page"
      show-footer
      fixed="left"
    >
      <vxe-table-column
        type="selection"
        width="60"
        fixed="left"
      />
      <vxe-table-column
        fixed="left"
        type="index"
        title="序号"
        width="60"
      />
      <bsp-table-column
        title="操作"
        fixed="left"
      >
        <template slot-scope="scope">
          <div class="ciic-table-operate" >
            <el-button type="text"   @click="showDialog(scope.row)"><i class="el-icon-search el-icon--right"></i>详情</el-button>
            <el-button type="text"   @click="deleteRow(scope.row)"><i class="el-icon-delete el-icon--right"></i>删除</el-button>
          </div>
        </template>
      </bsp-table-column>
      <bsp-table-column
        field="id"
        title="ID"
        filter-type="input"
        :showPagination="false"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        field="name"
        title="姓名"
        set-id="3"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        field="idType"
        filter-type="select"
        title="证件类型（翻译）"
        set-id="3159"
        multiple="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.idType | dictFilter(dicts) }}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        field="idCard"
        title="身份证"
        sortable
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.idCard }}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        field="gender"
        filter-type="select"
        title="性别"
        :optionProps="{value:'codeId',label:'label'}"
        :optionsList="sexList"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.gender | dictFilter(dicts) }}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        field="birthday"
        title="出身日期"
        filter-rule="between"
        filter-type="datePicker"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.birthday }}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        field="achievement"
        title="成绩"
        sortable
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.achievement }}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        v-if="cityList.length>0"
        field="city"
        filter-rule="in"
        title="市区"
        align="center"
        filter-type="select"
        :optionProps="{value:'codeItemId',label:'codeItemName'}"
        :optionsList="cityList"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.city | dictFilter(serverDictsMap) }}</span>
        </template>
      </bsp-table-column>
    </bsp-table>
    <el-dialog
      ref="testDialog"
      width="70%"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
    >
      <demo-form
        ref="testForm"
        :list-form.sync="listForm"
      />
      <div
        class="marginTop30"
        style="text-align: center"
      >
        <el-button
          type="primary"
          @click="handlerListForm"
        >
          保存
        </el-button>
        <el-button @click="dialogFormVisible = false">
          取消
        </el-button>
      </div>
    </el-dialog>
    <!--打开发票拆分弹层-->
    <div class="zhezhao" v-if="invoiceOpen"></div>
  </div>
</template>

<script>
    import defaultInvoice from "@/components/bsp/bsp-dicts-invoice/default";
    import bspTable from "@/components/bsp/bsp-table/bsp-table";
    import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
    import { getListpage,updateListpage,addListpage,deleteData,donwloadCityFile } from  "@/api/demo/demo"
    import {getServerDictsMap, getServerDictsList, getDictsListBySetId} from '@/api/sys/code'
    import demoForm from "./demo-form";
    import { mapGetters } from 'vuex';
    import exportMethod from "@/util/export";
    import { downloadFile } from '@/util/util';
    export default {
        name: "Table",
        components: {demoForm, bspTableColumn, bspTable},
        created(){
        //  this.getServerDictsMap();
         // this.getServerDictsList();
          this._getListpage()
          this.idcardList = this.dicts.codeList['3159']

        },
        mounted() {

        },
      computed: {
        ...mapGetters([
          'dicts',
          'pms'
        ]),
      },
        data(){
            return{
                buttons: {},
                dialogFormVisible: false,
                serverDictsMap: null,
                serverDictsList:null,
                cityList:[],
                list: [],
                idcardList: [],
                sexList: [{
                    codeId: '1',
                    label: '已提交'
                }, {
                    codeId: '2',
                    label: '审核中'
                },{
                    codeId: '3',
                    label: '已完成'
                }],
                listQuery:{
                    limit: 20,
                    page: 1,
                    total: 0,
                    name: '234',
                    idCard: '',

                },
                listForm: {
                  fileIds:'',
                  photo:'',
                  fileId:'',
                },
                id:'',

                textMap: {
                    add: '新增',
                    update: '编辑'
                },
                dialogStatus: 'add',
            }
        },
        methods: {
          // 格式化空值
          formatEmpty({ cellValue }){
            if(cellValue){
              return cellValue
            }else{
              return "--"
            }
          },
          // 格式化空值
          formatXiaotax({ cellValue, row, column }){
            if(row.total&&row.tax){
              return row.total*parseFloat(row.tax)/100
            }else{
              return "--"
            }
          },
          //回到上一层
          backPrev(){
            this.invoiceSelect = true;
          },

          footerMethod ({ columns, data }) {
            return [
              columns.map((column, columnIndex) => {
                if (columnIndex === 0) {
                  return this.$t('sum')
                }
                if (['achievement'].includes(column.property)) {
                  console.log(column.property)
                  return this.$utils.sum(data, column.property)
                }
                return null
              })
            ]
          },
          getServerDictsMap() {
            getServerDictsMap().then(res => {
              console.log("排除后的项")
              console.log(res)
              this.serverDictsMap = res.data.data
            })
          },
          getServerDictsList() {
            getServerDictsList().then(res => {
              console.log("排除后的代码集")
              console.log(res)
              this.serverDictsList = res.data.data;
              this.cityList = this.serverDictsList[1026]
            })
          },
            //复选框单选事件
            selectChange({ checked, row }){
                console.log(checked, row)
            },
            //复选框全选事件
            selectAll({checked, selection}){
                console.log(checked, selection)
            },
          //导出表格
          exportTable() {
            let obj = {
                columns:this.$refs['accountTable'].tableColums,
                ...this.listQuery,
                type: 'excel',
                fileName: 'Demo表格数据.xls',
                beanName: 'demoPersonServiceImpl',
                methodName: 'queryListPage',
                headerRowNum: 1,
                isSort: false
            };
            // exportMethod({columns: this.$refs['accountTable'].tableColums, ...this.listQuery}, '/wage');
              exportMethod(obj,'/wage');
          },
            //导入excle文件
            importExcle() {
                // 去excle上传页面
                this.$router.push({
                    path: '/batchParent'
                })

            },
            //获取列表数据
            _getListpage(){
                getListpage(this.listQuery).then(res => {
                  this.listQuery.total = res.data.total
                  this.list = res.data.records
                })
            },
            //展示新增表格
            showAddList(){
                // if(this.$refs['listForm']){
                //     this.$refs['listForm'].resetFields();
                // }
                this.listForm = {}
                this.dialogFormVisible = true
                this.dialogStatus='add'
            },
            //展示编辑表单框
            showDialog(row){
                this.dialogFormVisible = true
                this.dialogStatus='update'
                this.listForm = row
            },
            //删除数据
            deleteRow(row){
                this.id = row.id;
                deleteData(this.id).then(res=>{
                  this.$message.success("删除成功")
                  this._getListpage();
                })
            },
            addList() {
                console.log(this.listForm)
                let childForm = this.$refs.testForm.$refs.listForm
                childForm.validate((valid) => {
                    if (valid) {
                        addListpage(this.listForm).then(res => {
                            this.dialogFormVisible = false
                            this.$message.success('新增成功');
                            this._getListpage();
                        })
                    }
                })
            },
            //编辑表格
            updateListForm() {
                let childForm = this.$refs.testForm.$refs.listForm
                console.log(this.listForm)
                childForm.validate((valid) => {
                    if (valid) {
                        updateListpage(this.listForm).then(res => {
                            this.dialogFormVisible = false
                            this.$message.success('修改成功');
                            this._getListpage();
                        })
                    }
                })

            },
            handlerListForm() {
                if (this.dialogStatus == 'add') {
                    this.addList()
                } else if (this.dialogStatus == 'update') {
                    this.updateListForm()
                }
            },
          donwloadCity(){
            donwloadCityFile().then(res=>{
              downloadFile(res)
            })
          },
          openInvoiceType(){
            this.invoiceOpen = true;
          },
          openDefaultSplit(){
            console.log(2)
          },
          openMoreHeadSplit(){
            console.log(3)
          },

          //发票
          changeInvoiceType(n){
            this.invoiceActive !== n ? this.invoiceActive = n:null;
          },
          splitDetail(){
            this.invoiceSelect = false;

          },
          splitCancel(){
            this.invoiceOpen = false;
          }
        }
    }
</script>

<style scoped>

</style>
